import { loadable } from '@change-corgi/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'feed',
		path: '/p/:slug/v',
		component: loadable(async () => import(/* webpackChunkName: "pages/feed" */ './index'), {
			exportName: 'Feed',
			fallback: Loading,
		}),
		frame: {
			header: true,
			footer: true,
		},
		restrictedAccess: {
			authOnly: true,
			role: ['staff', 'support'],
		},
		ssr: {
			// switch this to true to enable SSR
			enabled: false,
			seo: false,
		},
	},
];
